import React from 'react';
const backgroundRed = { background: 'red' };

const Row = ({ params, row }) => <tr>{getValues(params, row)}</tr>;

function getValues(params, row) {
    return params.map((param, index) => {
        const value = row[index];
        const styles = value < 0 ? backgroundRed : {};

        return <td key={param} style={styles} >{value}</td>;
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PropellerAdsReport/components/Table/components/Row/index.js